var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.9971,
    height: 17.9971,
    viewBox: "0 0 17.9971 17.9971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7475 11.2482V14.2477C15.7475 14.6455 15.5895 15.0269 15.3082 15.3082C15.0269 15.5895 14.6455 15.7475 14.2477 15.7475H3.7494C3.35164 15.7475 2.97017 15.5895 2.68891 15.3082C2.40765 15.0269 2.24964 14.6455 2.24964 14.2477V11.2482",
    stroke: "#101010",
    strokeWidth: 1.49976
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.24915 7.49879L8.99855 11.2482L12.7479 7.49879",
    stroke: "#101010",
    strokeWidth: 1.49976
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.99855 11.2482V2.24964",
    stroke: "#101010",
    strokeWidth: 1.49976
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4a6a383a7c341ce9ddcfd7602d91072f.svg";
export { ForwardRef as ReactComponent };